// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__27Pfb","image":"styles_image__3qFz0"};